import * as Cesium from "cesium";

export function rulerInit(viewer) {
  let isDrawingEnabled = false;

  let polylines = [];
  let polylineIndex = 0;

  let currentPolyline = {
    id: polylineIndex,
    positions: [],
    distances: [],
    labels: [],
    tempPosition: null,
  };

  function addPoint(cartesian) {
    if (!cartesian) {
      console.error("Координаты не определены.");
      return;
    }
  
    // Проверка на совпадение с последней точкой предыдущей полилинии
    if (currentPolyline.positions.length === 0 && polylines.length > 0) {
      let lastPolyline = polylines[polylines.length - 1];
      let lastPosition = lastPolyline.positions[lastPolyline.positions.length - 1];
  
      if (Cesium.Cartesian3.equals(lastPosition, cartesian)) {
        return;
      }
    }
  
    // Проверка на совпадение с последней точкой текущей полилинии
    if (
      currentPolyline.positions.length > 0 &&
      Cesium.Cartesian3.equals(currentPolyline.positions[currentPolyline.positions.length - 1], cartesian)
    ) {
      finalizePolyline();
      return;
    }
  
    viewer.entities.removeById("tempLabel");
    viewer.entities.removeById("tempPoint");
  
    currentPolyline.positions.push(cartesian);
    updatePolyline();
    calculateDistance();
    updateLabels();
    updatePoints();
  }

  function updatePolyline() {
    if (currentPolyline.positions.length < 2) return;

    viewer.entities.removeById("polyline_" + currentPolyline.id);
    viewer.entities.add({
      id: "polyline_" + currentPolyline.id,
      polyline: {
        positions: new Cesium.CallbackProperty(function () {
          return currentPolyline.positions;
        }, false),
        width: 6,
        material: new Cesium.PolylineOutlineMaterialProperty({
          outlineColor: Cesium.Color.WHITE,
          color: Cesium.Color.fromCssColorString("#E59E6D"),
          outlineWidth: 4,
        }),
      },
    });

    if (currentPolyline.tempPosition) {
      updateTempPolyline();
    }
  }

  function updateTempPolyline() {
    if (!currentPolyline.tempPosition || currentPolyline.positions.length < 1)
      return;

    viewer.entities.removeById("tempPolyline");
    viewer.entities.add({
      id: "tempPolyline",
      polyline: {
        positions: new Cesium.CallbackProperty(function () {
          let tempPositions = currentPolyline.positions.slice();
          tempPositions.push(currentPolyline.tempPosition);
          return tempPositions;
        }, false),
        width: 6,
        material: new Cesium.PolylineOutlineMaterialProperty({
          outlineColor: Cesium.Color.WHITE,
          color: Cesium.Color.fromCssColorString("#E59E6D").withAlpha(0.75),
          outlineWidth: 4,
        }),
      },
    });
  }

  function calculateDistance() {
    if (currentPolyline.positions.length < 2) return;

    let cumulativeDistances = [];
    let geodesic = new Cesium.EllipsoidGeodesic();

    for (let i = 0; i < currentPolyline.positions.length - 1; i++) {
      let start = currentPolyline.positions[i];
      let end = currentPolyline.positions[i + 1];
      geodesic.setEndPoints(
        Cesium.Cartographic.fromCartesian(start),
        Cesium.Cartographic.fromCartesian(end),
      );
      cumulativeDistances.push(geodesic.surfaceDistance);
    }
    currentPolyline.distances = cumulativeDistances;
  }

  function updateLabels() {
    currentPolyline.labels.forEach(function (label) {
      viewer.entities.remove(label);
    });
    currentPolyline.labels = [];

    for (let i = 0; i < currentPolyline.positions.length; i++) {
      let label = viewer.entities.add({
        position: currentPolyline.positions[i],
        label: {
          text:
            i === 0
              ? "Start"
              : Math.round(currentPolyline.distances[i - 1]) + " m",
          font: "700 16px 'Cairo'",
          fillColor: Cesium.Color.fromCssColorString("#362044"),
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 2,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(10, -20),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
      });

      currentPolyline.labels.push(label);
    }
  }

  function updatePoints() {
    for (let i = 0; i < currentPolyline.positions.length; i++) {
      viewer.entities.removeById("point_" + currentPolyline.id + "_" + i);

      viewer.entities.add({
        id: "point_" + currentPolyline.id + "_" + i,
        position: currentPolyline.positions[i],
        point: {
          pixelSize: 12,
          color: Cesium.Color.fromCssColorString("#E59E6D"),
          outlineColor: Cesium.Color.WHITE,
          outlineWidth: 5,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
      });
    }
  }

  let tempLabel;

  function updateTempLabel() {
    if (!currentPolyline.tempPosition || currentPolyline.positions.length < 1)
      return;

    viewer.entities.removeById("tempLabel");

    let geodesic = new Cesium.EllipsoidGeodesic();
    geodesic.setEndPoints(
      Cesium.Cartographic.fromCartesian(
        currentPolyline.positions[currentPolyline.positions.length - 1],
      ),
      Cesium.Cartographic.fromCartesian(currentPolyline.tempPosition),
    );

    let distance = geodesic.surfaceDistance;
    let midpoint = Cesium.Cartesian3.lerp(
      currentPolyline.positions[currentPolyline.positions.length - 1],
      currentPolyline.tempPosition,
      0.5,
      new Cesium.Cartesian3(),
    );

    viewer.entities.add({
      id: "tempLabel",
      position: midpoint,
      label: {
        text: Math.ceil(distance) + "m",
        font: "700 16px 'Cairo'",
        fillColor: Cesium.Color.fromCssColorString("#362044"),
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 2,
        verticalOrigin: Cesium.VerticalOrigin.TOP,
        pixelOffset: new Cesium.Cartesian2(0, -20),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      },
    });

    viewer.entities.removeById("tempPoint");
    viewer.entities.add({
      id: "tempPoint",
      position: currentPolyline.tempPosition,
      point: {
        pixelSize: 12,
        color: Cesium.Color.fromCssColorString("#E59E6D").withAlpha(0.75),
        outlineColor: Cesium.Color.WHITE.withAlpha(0.75),
        outlineWidth: 5,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      },
    });
  }

  function finalizePolyline() {
    if (currentPolyline.positions.length < 2) return;

    viewer.entities.removeById("tempLabel");
    viewer.entities.removeById("tempPoint");

    if (currentPolyline.labels.length > 0) {
      viewer.entities.remove(
        currentPolyline.labels[currentPolyline.labels.length - 1],
      );
    }

    polylines.push({
      positions: currentPolyline.positions.slice(),
      distances: currentPolyline.distances.slice(),
      totalDistance: currentPolyline.distances.reduce((acc, d) => acc + d, 0),
      id: polylineIndex,
    });

    let lastPosition =
      currentPolyline.positions[currentPolyline.positions.length - 1];
    let totalDistanceLabel = viewer.entities.add({
      position: lastPosition,
      label: {
        text: Math.round(polylines[polylines.length - 1].totalDistance) + "m",
        font: "700 16px 'Cairo'",
        fillColor: Cesium.Color.fromCssColorString("#362044"),
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        outlineColor: Cesium.Color.WHITE,
        outlineWidth: 2,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(10, -20),
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      },
    });

    currentPolyline.labels.push(totalDistanceLabel);

    polylineIndex++;

    currentPolyline = {
      id: polylineIndex,
      positions: [],
      distances: [],
      labels: [],
      tempPosition: null,
    };

    updateAllPolylines();
  }

  function updateAllPolylines() {
    polylines.forEach((polyline) => {
      viewer.entities.removeById("polyline_" + polyline.id);

      viewer.entities.add({
        id: "polyline_" + polyline.id,
        polyline: {
          positions: polyline.positions,
          width: 6,
          material: new Cesium.PolylineOutlineMaterialProperty({
            outlineColor: Cesium.Color.WHITE,
            color: Cesium.Color.fromCssColorString("#E59E6D"),
            outlineWidth: 4,
          }),
        },
      });
    });
  }

  updateAllPolylines();

  function clearAllEntities() {
    viewer.entities.removeAll();

    polylines = [];
    currentPolyline = {
      id: 0,
      positions: [],
      distances: [],
      labels: [],
      tempPosition: null,
    };

    polylineIndex = 0;
  }

  function enablePolylineDrawing() {
    isDrawingEnabled = true;

    viewer.screenSpaceEventHandler.setInputAction(function (click) {
      let cartesian = viewer.camera.pickEllipsoid(
        click.position,
        viewer.scene.globe.ellipsoid,
      );
      
      if (cartesian) {
        addPoint(cartesian);
      } else {
        console.error("Не удалось получить координаты из клика.");
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    viewer.screenSpaceEventHandler.setInputAction(function (movement) {
      let cartesian = viewer.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid,
      );
      if (cartesian) {
        currentPolyline.tempPosition = cartesian;
        updateTempPolyline();
        updateTempLabel();
      } else {
        currentPolyline.tempPosition = null;
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    viewer.screenSpaceEventHandler.setInputAction(function (movement) {
      // console.log("Двойное нажатие отключено тут")
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
  }


  function disablePolylineDrawing() {
    isDrawingEnabled = false;

    clearAllEntities();

    viewer.screenSpaceEventHandler.removeInputAction(
      Cesium.ScreenSpaceEventType.LEFT_CLICK,
    );
    viewer.screenSpaceEventHandler.removeInputAction(
      Cesium.ScreenSpaceEventType.MOUSE_MOVE,
    );
  }

  return { on: enablePolylineDrawing, off: disablePolylineDrawing };
}
